import Component from '@cell/cell-core/component/component';
import './form.scss';

class Form extends Component {
  constructor() {
    super();

    this.errorAlertElement = null;
  }

  componentDidMount() {
    this.on('c-button.click.submit_form', this.submit.bind(this), {
      preventDefault: true,
    });

    this.on('c-input.input', this.handleInput.bind(this));
  }

  submit() {
    const data = [...this.querySelectorAll('c-input')].reduce((obj, inputElement) => {
      obj[inputElement.getName()] = inputElement.getValue();

      return obj;
    }, {});

    this.emit('submit_form', data);
  }

  handleInput() {
    this.hideErrorAlert();
  }

  showSuccessAlert() {
    const alertElement = this.querySelector('template[data-success]').content.cloneNode(true);

    this.appendChild(alertElement);

    this.querySelector('.Form__Form').style.display = 'none';
  }

  showErrorAlert() {
    // Error already visible. Nothing to do here.
    if (this.errorAlertElement) return;

    const alertElement = this.querySelector('template[data-error]').content.cloneNode(true);

    this.appendChild(alertElement);

    this.errorAlertElement = [...this.children].at(-1);
  }

  hideErrorAlert() {
    if (this.errorAlertElement) {
      this.errorAlertElement.parentNode.removeChild(this.errorAlertElement);

      this.errorAlertElement = null;
    }
  }
}

customElements.define('c-form', Form);
